import { v4 as uuid } from 'uuid';
var debug = 0;

/**
 * disables random uuid generation in favour of incremental generation
 */
export function setDebugMode() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  debug = Number(value);
}

/* eslint-disable-next-line no-plusplus */
var randomGen = function randomGen() {
  return debug && "000000000000000".concat(debug++).substr(-16);
};

/**
 * uuid может принимать string - в этом случае возвращает всегда нужное значение
 * FIXME: В идеале все подобные действия лучше делать на уровне jest.mock'а
 */
export default (function () {
  return uuid({
    random: randomGen()
  }).replace(/-/g, '').substr(-24);
});